(function () {
  'use strict';
  if (window.SamplesShortlist) { window.SamplesShortlist.init(); return; }

  var KEY = 'cksc_samples_shortlist';
  var TTL = 24 * 60 * 60 * 1000;
  var DEFAULTS = {
    threshold: 3,
    percent: 40,
    strings: {
      title_one: '[count] sample picked',
      title_other: '[count] samples picked',
      under: 'Add [remaining] more and all three are [percent]% off: [set_discounted] instead of [set_total].',
      hit: '[percent]% off applied. All [count] samples for [discounted], down from [total].',
      over: '[percent]% off applies to all [count]. Add [remaining] more to try a second colourway.',
      many: '[percent]% off applies to all [count]. [discounted] instead of [total].',
      progress: '[count] / [threshold] to save [percent]%',
      badge: '[percent]% off applied',
      saving: 'Saving [saving]',
      each: '[count] × [unit]',
      add_one: 'Add [count] sample to cart',
      add_other: 'Add [count] samples to cart',
      remove: 'Remove [title]',
      status_zero: 'Pick [threshold] save [percent]%',
      status_under: '[count] of [threshold] picked. Add [remaining] more to save [percent]%',
      status_on: '[count] picked. [percent]% off applied.',
      error: 'Those samples didn’t make it into your cart. Please try again.',
      adding: 'Adding your samples to cart',
      kit_zero: 'Tick [threshold] and the set is [set_discounted].',
      kit_under: '[count] picked. Add [remaining] more and the set is [set_discounted].',
      kit_on: '[count] picked. [percent]% off applied.',
      kit_count_zero: 'This sample · [unit]',
      kit_count_one: '[count] sample · [discounted]',
      kit_count_other: '[count] samples · [discounted]',
      kit_would: '[threshold] samples would be [set_discounted]',
      kit_saving: 'You save [saving]',
      kit_add_zero: 'Add this sample to cart · [unit]',
      kit_add_one: 'Add [count] sample to cart · [discounted]',
      kit_add_other: 'Add [count] samples to cart · [discounted]',
      kit_chip: '[colour] on the wall',
      kit_chip_close: '[colour] up close',
      kit_chip_arrives: 'What arrives: A4 sheet'
    }
  };
  var X_ICON = '<svg viewBox="0 0 10 10" width="8" height="8" aria-hidden="true"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';

  var items = [];
  var config = DEFAULTS;
  var busy = false;

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function loadConfig() {
    var c = { strings: {} };
    all('[data-ss-config]').forEach(function (el) {
      var o = {};
      try { o = JSON.parse(el.textContent) || {}; } catch (e) { o = {}; }
      if (o.threshold && !c.threshold) c.threshold = o.threshold;
      if (o.percent && !c.percent) c.percent = o.percent;
      Object.keys(o.strings || {}).forEach(function (k) { if (o.strings[k] && !c.strings[k]) c.strings[k] = o.strings[k]; });
    });
    var strings = {};
    Object.keys(DEFAULTS.strings).forEach(function (k) {
      strings[k] = (c.strings && c.strings[k]) ? c.strings[k] : DEFAULTS.strings[k];
    });
    config = {
      threshold: parseInt(c.threshold, 10) || DEFAULTS.threshold,
      percent: parseInt(c.percent, 10) || DEFAULTS.percent,
      strings: strings
    };
  }

  function load() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null');
      items = d && Array.isArray(d.items) && (Date.now() - d.t) < TTL ? d.items : [];
      if (!items.length) localStorage.removeItem(KEY);
    } catch (e) {}
  }

  function save() {
    try {
      if (items.length) localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), items: items }));
      else localStorage.removeItem(KEY);
    } catch (e) {}
    render();
  }

  function has(id) {
    return items.some(function (i) { return String(i.id) === String(id); });
  }

  function add(el) {
    var id = el.dataset.ssId;
    if (!id || has(id)) return;
    items.push({
      id: String(id),
      title: el.dataset.ssTitle || '',
      img: el.dataset.ssImg || '',
      price: parseInt(el.dataset.ssPrice, 10) || 0,
      url: el.dataset.ssUrl || ''
    });
    save();
  }

  function remove(id) {
    items = items.filter(function (i) { return String(i.id) !== String(id); });
    save();
  }

  function money(cents) {
    var format = ((window.theme && window.theme.moneyFormat) || '${{amount}}').replace(/<[^>]*>/g, '');
    var value = (cents || 0) / 100;
    var group = function (n, sep) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      var parts = value.toFixed(2).split('.');
      if (key === 'amount_no_decimals') return group(String(Math.round(value)), ',');
      if (key === 'amount_with_comma_separator') return group(parts[0], '.') + ',' + parts[1];
      if (key === 'amount_no_decimals_with_comma_separator') return group(String(Math.round(value)), '.');
      if (key === 'amount_with_apostrophe_separator') return group(parts[0], "'") + '.' + parts[1];
      return group(parts[0], ',') + '.' + parts[1];
    });
  }

  function fill(str, t) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return t[k] !== undefined ? t[k] : m; });
  }

  function tokens() {
    var n = items.length;
    var th = config.threshold;
    var pc = config.percent;
    var total = items.reduce(function (s, i) { return s + (i.price || 0); }, 0);
    var on = n >= th;
    var disc = on ? Math.round(total * (100 - pc) / 100) : total;
    var unit = n ? Math.round(total / n) : baseUnit();
    var setTotal = unit * th;
    var remaining = n < th ? th - n : (n < th * 2 ? th * 2 - n : 0);
    return {
      n: n, on: on,
      count: n, threshold: th, percent: pc, remaining: remaining,
      total: money(total), discounted: money(disc), saving: money(total - disc), unit: money(unit),
      set_total: money(setTotal), set_discounted: money(Math.round(setTotal * (100 - pc) / 100))
    };
  }

  function message(t) {
    var s = config.strings;
    if (t.n < t.threshold) return fill(s.under, t);
    if (t.n === t.threshold) return fill(s.hit, t);
    if (t.n < t.threshold * 2) return fill(s.over, t);
    return fill(s.many, t);
  }

  function setText(root, sel, text) {
    var el = root.querySelector(sel);
    if (el) el.textContent = text;
  }

  function show(root, sel, on) {
    var el = root.querySelector(sel);
    if (el) el.hidden = !on;
  }

  function segments(count, filled, cls) {
    var html = '';
    for (var i = 0; i < count; i++) html += '<span class="' + cls + (i < filled ? ' is-on' : '') + '"></span>';
    return html;
  }

  function renderBar(bar, t) {
    var s = config.strings;
    var open = t.n > 0;
    bar.classList.toggle('is-open', open);
    bar.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (!open) { show(bar, '[data-ss-error]', false); return; }

    setText(bar, '[data-ss-heading]', fill(t.n === 1 ? s.title_one : s.title_other, t));
    setText(bar, '[data-ss-msg]', message(t));
    setText(bar, '[data-ss-badge]', fill(s.badge, t));
    show(bar, '[data-ss-badge]', t.on);
    setText(bar, '[data-ss-progress-label]', fill(s.progress, t));
    show(bar, '[data-ss-progress]', !t.on);
    setText(bar, '[data-ss-saving]', fill(s.saving, t));
    show(bar, '[data-ss-saving]', t.on);
    setText(bar, '[data-ss-was]', t.total);
    show(bar, '[data-ss-was]', t.on);
    setText(bar, '[data-ss-now]', t.discounted);
    setText(bar, '[data-ss-each]', fill(s.each, t));
    setText(bar, '[data-ss-add-label]', fill(t.n === 1 ? s.add_one : s.add_other, t));
    setText(bar, '[data-ss-add-price]', t.discounted);

    var segs = bar.querySelector('[data-ss-segs]');
    if (segs) segs.innerHTML = segments(t.threshold, t.n, 'ss-seg');

    var thumbs = bar.querySelector('[data-ss-thumbs]');
    if (!thumbs) return;
    thumbs.textContent = '';
    var maxThumbs = 4;
    var minSquares = 3;
    items.slice(0, maxThumbs).forEach(function (i) {
      var wrap = document.createElement('span');
      wrap.className = 'ss-thumb';
      if (i.img) {
        var img = document.createElement('img');
        img.src = i.img;
        img.alt = '';
        img.width = 48;
        img.height = 48;
        wrap.appendChild(img);
      }
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'ss-thumb__x';
      x.setAttribute('data-ss-remove', i.id);
      x.setAttribute('aria-label', fill(s.remove, { title: i.title }));
      x.innerHTML = X_ICON;
      wrap.appendChild(x);
      thumbs.appendChild(wrap);
    });
    if (t.n > maxThumbs) {
      var more = document.createElement('span');
      more.className = 'ss-thumb ss-thumb--more';
      more.textContent = '+' + (t.n - maxThumbs);
      thumbs.appendChild(more);
    }
    for (var e = t.n; e < minSquares; e++) {
      var slot = document.createElement('span');
      slot.className = 'ss-thumb ss-thumb--slot';
      slot.setAttribute('aria-hidden', 'true');
      slot.textContent = '+';
      thumbs.appendChild(slot);
    }
  }

  function render() {
    var t = tokens();
    var s = config.strings;

    all('[data-ss-check]').forEach(function (cb) {
      var on = has(cb.dataset.ssId);
      cb.checked = on;
      var card = cb.closest('[data-ss-card]');
      if (card) card.classList.toggle('is-selected', on);
    });

    all('[data-ss-toggle]').forEach(function (btn) {
      var on = has(btn.dataset.ssId);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-ss-toggle-label]');
      if (label) label.textContent = on ? btn.dataset.ssLabelOn : btn.dataset.ssLabelOff;
    });

    all('[data-ss-status]').forEach(function (el) {
      el.textContent = fill(t.n === 0 ? (el.getAttribute('data-ss-status-zero') || s.status_zero) : (t.on ? s.status_on : (el.getAttribute('data-ss-status-under') || s.status_under)), t);
    });

    all('[data-ss-dots]').forEach(function (el) {
      el.innerHTML = segments(t.threshold, t.n, 'ss-dot');
    });

    all('[data-ss-kit]').forEach(function (root) { renderKit(root, t); });

    var bars = all('[data-ss-bar]');
    bars.forEach(function (bar) { renderBar(bar, t); });
    document.body.classList.toggle('ss-bar-open', bars.length > 0 && t.n > 0);
  }

  function baseUnit() {
    var el = document.querySelector('[data-ss-unit]');
    return el ? (parseInt(el.getAttribute('data-ss-unit'), 10) || 0) : 0;
  }

  function renderKit(root, t) {
    var s = config.strings;
    setText(root, '[data-ss-kit-progress]', fill(t.n === 0 ? s.kit_zero : (t.on ? s.kit_on : s.kit_under), t));
    setText(root, '[data-ss-kit-fraction]', Math.min(t.n, t.threshold) + ' / ' + t.threshold);
    var segs = root.querySelector('[data-ss-kit-segs]');
    if (segs) segs.innerHTML = segments(t.threshold, t.n, 'ss-kit__seg');
    setText(root, '[data-ss-kit-count]', fill(t.n === 0 ? s.kit_count_zero : (t.n === 1 ? s.kit_count_one : s.kit_count_other), t));
    setText(root, '[data-ss-kit-would]', fill(t.on ? s.kit_saving : s.kit_would, t));
    setText(root, '[data-ss-kit-add]', fill(t.n === 0 ? s.kit_add_zero : (t.n === 1 ? s.kit_add_one : s.kit_add_other), t));
  }

  function initKit(root) {
    if (root._ssKit) return;
    var current = root.querySelector('.ss-kit__tile.is-current');
    var main = (parseInt(root.dataset.ssMainIndex, 10) || 1) - 1;
    var list = current ? cardImages(current) : [];
    var pos = kitOrder(list.length, main);
    root._ssKit = {
      main: main,
      arrives: (parseInt(root.dataset.ssArrivesIndex, 10) || 1) - 1,
      pos: pos,
      images: pos.map(function (k) { return list[k]; }),
      colour: current ? (current.dataset.ssColourName || '') : '',
      i: 0
    };
  }

  function kitOrder(n, main) {
    var pos = [];
    for (var k = 0; k < n; k++) pos.push(k);
    if (main <= 0 || main >= n) return pos;
    return [main].concat(pos.slice(0, main), pos.slice(main + 1));
  }

  function kitChip(root) {
    var st = root._ssKit;
    var chip = root.querySelector('.ss-kit__chip-label');
    if (!st || !chip) return;
    var p = st.pos[st.i];
    var s = config.strings;
    var text = p === st.main ? s.kit_chip : (p === 0 ? s.kit_chip_close : (p === st.arrives ? s.kit_chip_arrives : ''));
    chip.hidden = !text;
    setText(root, '[data-ss-kit-chip]', fill(text, { colour: st.colour }));
  }

  function kitShow(root) {
    var st = root._ssKit;
    var img = root.querySelector('.ss-kit__main-img');
    if (!st || !img || !st.images.length) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = st.images[st.i];
    kitChip(root);
    var thumbs = root.querySelectorAll('[data-ss-kit-thumb]');
    for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.toggle('is-active', k === st.i);
  }

  function kitThumbs(root) {
    var st = root._ssKit;
    var wrap = root.querySelector('[data-ss-kit-thumbs]');
    if (!st || !wrap) return;
    var first = wrap.querySelector('[data-ss-kit-thumb]');
    var label = first ? first.getAttribute('aria-label').replace(/\s\d+$/, '') : '';
    wrap.innerHTML = st.images.map(function (src, k) {
      return '<button type="button" class="ss-kit__thumb" data-ss-kit-thumb="' + k + '" aria-label="' + label + ' ' + (k + 1) + '"><img src="' + src.replace(/width=\d+/, 'width=240') + '" alt="" loading="lazy"></button>';
    }).join('');
    wrap.hidden = st.images.length < 2;
  }

  function kitStep(root, dir) {
    var st = root._ssKit;
    if (!st || st.images.length < 2) return;
    st.i = (st.i + dir + st.images.length) % st.images.length;
    kitShow(root);
  }

  function kitStyle(root, btn) {
    var key = btn.dataset.ssKitStyle;
    all('[data-ss-kit-style]', root).forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    all('[data-ss-kit-tile]', root).forEach(function (tile) {
      tile.hidden = key !== 'all' && (' ' + (tile.dataset.ssStyles || '') + ' ').indexOf(' ' + key + ' ') === -1;
    });
  }

  function kitSet(root, tile) {
    var st = root._ssKit;
    var list = cardImages(tile);
    if (!st || !list.length) return;
    st.pos = kitOrder(list.length, st.main);
    st.images = st.pos.map(function (k) { return list[k]; });
    st.colour = tile.dataset.ssColourName || '';
    st.i = 0;
    kitThumbs(root);
    kitShow(root);
    var dot = root.querySelector('[data-ss-kit-dot]');
    if (dot) dot.style.setProperty('--dot', tile.dataset.ssDot || 'transparent');
    var wrap = root.querySelector('[data-ss-kit-arrives-wrap]');
    if (wrap) {
      var src = list[st.arrives];
      wrap.hidden = !src;
      var a = wrap.querySelector('img');
      if (a && src) {
        a.removeAttribute('srcset');
        a.removeAttribute('sizes');
        a.src = src;
      }
    }
  }

  function initWall(root) {
    if (root._ss) return;
    var per = parseInt(root.dataset.ssPerPage, 10) || 30;
    root._ss = { pattern: root.dataset.ssPattern || '0', colour: 'all', per: per, shown: per };
    var want = urlPattern();
    if (want) {
      var match = all('[data-ss-filter-pattern]', root).filter(function (b) {
        return (b.dataset.ssPatternHandle || '').toLowerCase() === want || slug(b.textContent) === want;
      })[0];
      if (match) {
        root._ss.pattern = match.dataset.ssFilterPattern;
        requestAnimationFrame(function () { root.scrollIntoView({ block: 'start' }); });
      }
    }
    applyWall(root);
  }

  function slug(s) { return String(s || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  function urlPattern() {
    var m = window.location.search.match(/[?&]pattern=([^&#]*)/);
    return m ? slug(decodeURIComponent(m[1].replace(/\+/g, ' '))) : '';
  }

  function applyWall(root) {
    var st = root._ss;
    var cards = all('[data-ss-card]', root);
    var inPattern = cards.filter(function (c) { return c.dataset.ssPattern === st.pattern; });
    var avail = {};
    inPattern.forEach(function (c) {
      (c.dataset.ssColour || '').split(' ').forEach(function (h) { if (h) avail[h] = true; });
    });
    if (st.colour !== 'all' && !avail[st.colour]) st.colour = 'all';

    var match = inPattern.filter(function (c) {
      return st.colour === 'all' || (' ' + c.dataset.ssColour + ' ').indexOf(' ' + st.colour + ' ') > -1;
    });
    cards.forEach(function (c) { c.hidden = true; });
    match.forEach(function (c, i) { c.hidden = i >= st.shown; });

    all('[data-ss-filter-pattern]', root).forEach(function (b) {
      var on = b.dataset.ssFilterPattern === st.pattern;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    all('[data-ss-filter-colour]', root).forEach(function (b) {
      var v = b.dataset.ssFilterColour;
      var on = v === st.colour;
      b.hidden = v !== 'all' && !avail[v];
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var shown = Math.min(st.shown, match.length);
    show(root, '[data-ss-more]', match.length > st.shown);
    setText(root, '[data-ss-shown]', shown);
    setText(root, '[data-ss-total]', match.length);
    show(root, '[data-ss-empty]', match.length === 0);
  }

  function wallClick(el) {
    var root = el.closest('[data-ss-wall]');
    if (!root || !root._ss) return;
    var st = root._ss;
    if (el.hasAttribute('data-ss-filter-pattern')) {
      st.pattern = el.dataset.ssFilterPattern;
      st.shown = st.per;
    } else if (el.hasAttribute('data-ss-filter-colour')) {
      st.colour = el.dataset.ssFilterColour;
      st.shown = st.per;
    } else {
      st.shown += st.per;
    }
    applyWall(root);
  }

  var hover = { card: null, timer: null, i: 0 };

  function cardImages(card) {
    return (card.dataset.ssImages || '').split('|').filter(Boolean);
  }

  function stopHover() {
    clearInterval(hover.timer);
    hover.timer = null;
    if (hover.card) hover.card.classList.remove('is-hovering');
    hover.card = null;
  }

  function startHover(card) {
    if (hover.card === card) return;
    stopHover();
    var list = cardImages(card).slice(1);
    var img = card.querySelector('.ss-card__img--wall');
    if (!list.length || !img) return;
    hover.card = card;
    hover.i = 0;
    if (img.getAttribute('src') !== list[0]) img.src = list[0];
    card.classList.add('is-hovering');
    if (list.length < 2) return;
    hover.timer = setInterval(function () {
      hover.i = (hover.i + 1) % list.length;
      var next = new Image();
      next.onload = function () { if (hover.card === card) img.src = next.src; };
      next.src = list[hover.i];
    }, 1300);
  }

  function openQuickLook(card) {
    var wall = card.closest('[data-ss-wall]');
    var dlg = wall ? wall.querySelector('[data-ss-ql]') : null;
    var cb = card.querySelector('[data-ss-check]');
    if (!dlg || !cb || typeof dlg.showModal !== 'function') {
      var link = card.querySelector('.ss-card__title');
      if (link) window.location.href = link.href;
      return;
    }
    stopHover();
    var d = card.dataset;
    var colour = d.ssColourName || '';
    var available = d.ssAvailable === 'true';

    setText(dlg, '[data-ss-ql-colour]', colour);
    setText(dlg, '[data-ss-ql-sub]', d.ssPatternName || '');
    setText(dlg, '[data-ss-ql-title]', (d.ssProductTitle || '') + (available && d.ssPriceLabel ? ' · ' + d.ssPriceLabel : ''));
    var dot = dlg.querySelector('[data-ss-ql-dot]');
    if (dot) {
      dot.hidden = !d.ssDot;
      dot.style.setProperty('--dot', d.ssDot || 'transparent');
    }

    var gallery = dlg.querySelector('[data-ss-ql-gallery]');
    if (gallery) {
      gallery.textContent = '';
      gallery.scrollLeft = 0;
      var badgeAt = parseInt(dlg.dataset.badgeIndex, 10) || 0;
      cardImages(card).forEach(function (src, idx) {
        var fig = document.createElement('figure');
        fig.className = 'ss-ql__fig';
        var box = document.createElement('div');
        box.className = 'ss-ql__img';
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.width = 900;
        img.height = 563;
        if (idx > 2) img.loading = 'lazy';
        box.appendChild(img);
        if (badgeAt === idx + 1 && dlg.dataset.badge) {
          var badge = document.createElement('span');
          badge.className = 'ss-ql__badge';
          badge.textContent = dlg.dataset.badge;
          box.appendChild(badge);
        }
        fig.appendChild(box);
        var caption = dlg.getAttribute('data-caption-' + (idx + 1));
        if (caption) {
          var fc = document.createElement('figcaption');
          fc.textContent = caption;
          fig.appendChild(fc);
        }
        gallery.appendChild(fig);
      });
    }

    var viewLink = dlg.querySelector('[data-ss-ql-link]');
    if (viewLink) viewLink.href = cb.dataset.ssUrl || '#';

    var addBtn = dlg.querySelector('[data-ss-ql-add]');
    if (addBtn) {
      ['ssId', 'ssTitle', 'ssImg', 'ssPrice', 'ssUrl'].forEach(function (k) { addBtn.dataset[k] = cb.dataset[k] || ''; });
      addBtn.dataset.ssLabelOff = fill(addBtn.dataset.labelOff, { colour: colour });
      addBtn.dataset.ssLabelOn = fill(addBtn.dataset.labelOn, { colour: colour });
      addBtn.setAttribute('data-ss-toggle', '');
      addBtn.hidden = !available;
    }

    if (!dlg._ssBound) {
      dlg._ssBound = true;
      dlg.addEventListener('close', function () { document.documentElement.classList.remove('ss-ql-lock'); });
    }
    loadRelated(dlg, card, colour);
    render();
    dlg.showModal();
    document.documentElement.classList.add('ss-ql-lock');
  }

  var relCache = {};

  function loadRelated(dlg, card, colour) {
    var wrap = dlg.querySelector('[data-ss-rel-wrap]');
    if (!wrap) return;
    var body = wrap.querySelector('[data-ss-rel-body]');
    var id = card.dataset.ssColourId || '';
    var token = (dlg._ssRelToken = (dlg._ssRelToken || 0) + 1);
    wrap.hidden = true;
    if (body) body.textContent = '';
    if (!id || !body) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var base = root + 'collections/' + (dlg.dataset.relCollection || 'all') + '?section_id=samples-related';
    var param = dlg.dataset.relFilter || 'filter.p.m.shopify.color-pattern';
    var first = base + '&' + encodeURIComponent(param) + '=' + encodeURIComponent('gid://shopify/Metaobject/' + id);

    fetchRel(first).then(function (doc) {
      var data = doc && doc.querySelector('[data-ss-rel]');
      if (!data || (parseInt(data.dataset.ssRelShown, 10) || 0) > 0) return doc;
      var json = doc.querySelector('[data-ss-rel-values]');
      var list = [];
      try { list = JSON.parse(json ? json.textContent : '[]'); } catch (e) {}
      var hit = list.filter(function (x) {
        var v = String(x.v || '');
        return v === id || v.slice(-id.length - 1) === '/' + id;
      })[0];
      if (!hit) return doc;
      return fetchRel(base + '&' + encodeURIComponent(hit.p) + '=' + encodeURIComponent(hit.v));
    }).then(function (doc) {
      if (token !== dlg._ssRelToken || !doc) return;
      var data = doc.querySelector('[data-ss-rel]');
      if (!data) return;
      var total = parseInt(data.dataset.ssRelTotal, 10) || 0;
      var shown = parseInt(data.dataset.ssRelShown, 10) || 0;
      if (!total || !shown) return;
      var t = { colour: colour, count: total };
      var sub = dlg.querySelector('[data-ss-ql-sub]');
      if (sub && dlg.dataset.relCount) {
        var pattern = card.dataset.ssPatternName || '';
        sub.textContent = (pattern ? pattern + ' · ' : '') + fill(dlg.dataset.relCount, t);
      }
      setText(wrap, '[data-ss-rel-title]', fill(dlg.dataset.relTitle, t));
      var allLink = wrap.querySelector('[data-ss-rel-all]');
      if (allLink) {
        allLink.textContent = fill(dlg.dataset.relAll, t) + ' \u2192';
        allLink.href = data.dataset.ssRelUrl || '#';
        allLink.hidden = total <= shown;
      }
      var grid = data.querySelector('.ss-rel__grid');
      if (!grid) return;
      all('[data-ss-rel-cta]', grid).forEach(function (el) { el.textContent = dlg.dataset.relCta || ''; });
      body.textContent = '';
      body.appendChild(document.importNode(grid, true));
      wrap.hidden = false;
    });
  }

  function fetchRel(url) {
    if (!relCache[url]) {
      relCache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      }).catch(function () { delete relCache[url]; return null; });
    }
    return relCache[url];
  }

  function initVideos() {
    var vids = all('[data-ss-video] video').filter(function (v) { return !v._ss; });
    if (!vids.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var play = function (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    var io = !reduce && 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) play(en.target); else en.target.pause(); });
    }, { rootMargin: '200px 0px' }) : null;
    vids.forEach(function (v) {
      v._ss = true;
      if (reduce) { v.controls = true; return; }
      if (io) io.observe(v); else play(v);
    });
  }

  function adding(on) {
    var el = document.querySelector('[data-ss-adding]');
    if (!el && on) {
      el = document.createElement('div');
      el.className = 'ss-adding';
      el.setAttribute('data-ss-adding', '');
      el.setAttribute('role', 'status');
      el.innerHTML = '<div class="ss-adding__box"><span class="ss-adding__spin" aria-hidden="true"></span><span></span></div>';
      document.body.appendChild(el);
    }
    if (!el) return;
    el.lastChild.lastChild.textContent = (config.strings && config.strings.adding) || 'Adding your samples to cart';
    el.classList.toggle('is-on', on);
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (drawer) { drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false })); return true; }
    var toggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
    if (toggle) { toggle.click(); return true; }
    return false;
  }

  function addToCart(btn) {
    if (busy) return;
    var fallback = btn.getAttribute('data-ss-fallback-id');
    var lines = items.length
      ? items.map(function (i) { return { id: Number(i.id), quantity: 1 }; })
      : (fallback ? [{ id: Number(fallback), quantity: 1 }] : []);
    if (!lines.length) return;
    busy = true;
    btn.setAttribute('aria-busy', 'true');
    adding(true);
    var leaving = false;
    var scope = btn.closest('[data-ss-bar],[data-ss-kit]');
    var err = scope ? scope.querySelector('[data-ss-error]') : null;
    if (err) err.hidden = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines })
    })
      .then(function (r) {
        return r.json().then(function (d) { if (!r.ok) throw d; return d; });
      })
      .then(function () {
        items = [];
        save();
        if (openCartDrawer()) {
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        } else {
          leaving = true;
          window.location.href = root + 'cart';
        }
      })
      .catch(function (d) {
        if (!err) return;
        err.textContent = (d && (d.description || d.message)) || config.strings.error;
        err.hidden = false;
      })
      .then(function () {
        busy = false;
        btn.removeAttribute('aria-busy');
        if (!leaving) adding(false);
      });
  }

  function bind() {
    document.addEventListener('change', function (e) {
      var sel = e.target && e.target.closest ? e.target.closest('[data-ss-kit-pattern]') : null;
      if (sel) {
        if (sel.value) window.location.href = sel.value;
        return;
      }
      var cb = e.target && e.target.closest ? e.target.closest('[data-ss-check]') : null;
      if (!cb) return;
      if (cb.checked) add(cb); else remove(cb.dataset.ssId);
    });

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var kitRoot = e.target.closest('[data-ss-kit]');
      if (kitRoot) {
        var thumb = e.target.closest('[data-ss-kit-thumb]');
        if (thumb && kitRoot._ssKit) { kitRoot._ssKit.i = parseInt(thumb.dataset.ssKitThumb, 10) || 0; kitShow(kitRoot); return; }
        var styleBtn = e.target.closest('[data-ss-kit-style]');
        if (styleBtn) { kitStyle(kitRoot, styleBtn); return; }
        var tile = e.target.closest('[data-ss-kit-tile]');
        if (tile) kitSet(kitRoot, tile);
      }
      var el = e.target.closest('[data-ss-ql-open]');
      if (el) {
        var card = el.closest('[data-ss-card]');
        if (card) openQuickLook(card);
        return;
      }
      el = e.target.closest('[data-ss-ql-close]');
      if (el) {
        var dlgClose = el.closest('dialog');
        if (dlgClose) dlgClose.close();
        return;
      }
      if (e.target.matches && e.target.matches('dialog[data-ss-ql]')) {
        e.target.close();
        return;
      }
      el = e.target.closest('[data-ss-toggle]');
      if (el) {
        e.preventDefault();
        if (has(el.dataset.ssId)) remove(el.dataset.ssId); else add(el);
        return;
      }
      el = e.target.closest('[data-ss-remove]');
      if (el) { remove(el.getAttribute('data-ss-remove')); return; }
      if (e.target.closest('[data-ss-clear]')) { items = []; save(); return; }
      el = e.target.closest('[data-ss-add]');
      if (el) { addToCart(el); return; }
      el = e.target.closest('[data-ss-filter-pattern],[data-ss-filter-colour],[data-ss-more-btn]');
      if (el) wallClick(el);
    });

    document.addEventListener('pointerover', function (e) {
      if (e.pointerType === 'touch') return;
      var card = e.target && e.target.closest ? e.target.closest('[data-ss-card]') : null;
      if (card) startHover(card);
    });

    document.addEventListener('pointerout', function (e) {
      if (hover.card && (!e.relatedTarget || !hover.card.contains(e.relatedTarget))) stopHover();
    });

    window.addEventListener('storage', function (e) {
      if (e.key === KEY) { load(); render(); }
    });

    document.addEventListener('shopify:section:load', init);
  }

  function init() {
    loadConfig();
    load();
    all('[data-ss-wall]').forEach(initWall);
    all('[data-ss-kit]').forEach(initKit);
    all('[data-ss-kit] .ss-kit__main').forEach(function (el) {
      var x0 = null, y0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) kitStep(el.closest('[data-ss-kit]'), dx < 0 ? 1 : -1);
      }, { passive: true });
    });
    initVideos();
    render();
  }

  window.SamplesShortlist = {
    init: init,
    items: function () { return items.slice(); }
  };

  bind();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
